import { TOAPopup } from '@setplex/arcana'
import { useUnit } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { $toa, $wasLoadingError, error } from '../model'
import { Body } from './Body'
import { Buttons } from './Buttons'
import { Error } from './Error'
import { TOALayout } from './TOALayout'

ToaPage.displayName = 'ToaPage'

export function ToaPage(): JSX.Element | null {
  const { t } = useTranslation()

  const { toa, err, wasLoadingError } = useUnit({
    toa: $toa,
    err: error.$loading,
    wasLoadingError: $wasLoadingError,
  })

  const emptyBody = Boolean(err || wasLoadingError)
  const subtitle = emptyBody ? '' : toa?.subject

  return (
    <TOALayout>
      <TOAPopup
        title={t('terms_of_agreements')}
        subtitle={subtitle}
        emptyBody={emptyBody}
      >
        <Body />
        <Buttons />
      </TOAPopup>
      <Error />
    </TOALayout>
  )
}
